import { render, staticRenderFns } from "./detalhes-custo-incorrido.vue?vue&type=template&id=f2079c08&scoped=true&"
import script from "./detalhes-custo-incorrido.vue?vue&type=script&lang=js&"
export * from "./detalhes-custo-incorrido.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=f2079c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2079c08",
  null
  
)

export default component.exports